import React, { Component } from 'react'
import moment from 'moment';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { development } from "../../libs/utils/Const";
import config from "../../config";
import { element } from 'prop-types';

class DetailPayments extends Component {

    mDocCum = (movement = {}) => {
        const { DocNum = '', ORCTDocNum = '', ObjType = '' } = movement
        let newDocNum = '';

        if (ObjType) {
            switch (Number(ObjType)) {
                case 13:
                    newDocNum = DocNum ?? '';
                    break;
                case 24:
                    newDocNum = ORCTDocNum ?? '';
                    break;
                default:
                    newDocNum = '';
                    break;
            }
        }
        return newDocNum;
    }

    mNumAtCard = (movement = {}) => {
        const { NumAtCard = '', ObjType = '', CertificateRef = '' } = movement
        let newDocNum = '';

        if (ObjType) {
            switch (Number(ObjType)) {
                case 13:
                    newDocNum = NumAtCard ?? '';
                    break;
                case 24:
                    newDocNum = CertificateRef ?? '';
                    break;
                default:
                    newDocNum = '';
                    break;
            }
        }
        return newDocNum;
    }

    showNumAtCard = (bodyElement = {}) => {
        const { NumAtCard = '', docObjectType = -1, CertificateRef = '' } = bodyElement
        let newDocNum = '';

        switch (Number(docObjectType)) {
            case 24:
                newDocNum = CertificateRef ?? '';
                break;
            default:
                newDocNum = NumAtCard ?? '';
                break;
        }
        return newDocNum;
    }
    getTipo = (bodyElement = {}) => {
        const { docObjectType, referenceType, GroupNum } = bodyElement;
        if (referenceType) return referenceType;
        switch (Number(docObjectType)) {
            case 13:
                return Number(GroupNum) === -1 ? 'Contado' : 'Crédito';
            case 24:
                return 'Recibo';
            case 30:
                return 'Percepción';
            default:
                return String(docObjectType ?? '');
        }
    }

    render() {
        const { Sales, Returns, MyDate, idSessionSelected, reprint, user, time, moneyMovements, gastosAdministrativos = [], cesionEnUso = [], paymentDetails = [] } = this.props
        const today = moment(new Date()).format('YYYY-MM-DD');
        const _user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        const baseFontStyle = { fontSize: '12px' };
        return (
            <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginBottom: "100px", ...baseFontStyle }}>
                <div className="row">
                    <div className="col-3">
                        <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                        <p className="text-center" style={baseFontStyle}>{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong></strong></p>

                    </div>
                    <div className="col-6 text-center">
                        <h5><strong>DETALLE DE FORMAS DE PAGO</strong></h5>
                    </div>
                    <div className="col-3">
                        <p style={baseFontStyle}>Sucursal: {_user?.Branch.CodeBranchOffice ?? ''}<br/>
                        <label>Folio: {idSessionSelected +"-"+ today.replace(/-/g, "")+"D"}</label></p>
                        <p style={baseFontStyle}>FECHA DE CIERRE: <br />{moment(MyDate).format('YYYY-MM-DD')}</p>

                    </div>
                </div>
                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2" style={baseFontStyle}>FORMAS DE PAGO</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                {Sales && Sales.DetailReport &&
                    Sales.DetailReport.map((element, index) => {
                        return (
                            <>
                                <div className='row mt-4' style={{ paddingRight: "15px" }}>
                                    <table className='mt-3'>
                                        <thead >
                                            <tr style={{ borderBottom: "solid 1px" }}>
                                                <th className="text-left" colSpan="2" style={baseFontStyle}>{element.NamePayMethod ?? ''}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div className='pl-0' style={{ width: "100%" }}>
                                        <table className='mt-2'>
                                            <thead >
                                                <tr>
                                                    <th className="text-left" style={baseFontStyle}>Cliente</th>
                                                    <th className="text-center" style={baseFontStyle}>Factura principal</th>
                                                    <th className="text-center" style={baseFontStyle}>No.Ref.de. cliente</th>
                                                    <th className="text-center" style={baseFontStyle}>No. Documento</th>
                                                    <th className="text-center" style={baseFontStyle}>Folio</th>
                                                    <th className="text-center" style={baseFontStyle}>Tipo</th>
                                                    <th className="text-right" style={baseFontStyle}>Monto</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {element && element.BodyPayMethod &&
                                                    element.BodyPayMethod.map((bodyElement, index) => {
                                                        const canceledStyle = bodyElement.CANCELED === 'Y'
                                                            ? { color: 'red' }
                                                            : {};

                                                        const detallesPago = Number(bodyElement.docObjectType) === 24 ? (paymentDetails?.filter( detail => String(detail.docNum) === String(bodyElement.DocNum)) ?? []) : [];
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr style={{ borderTop: '2px solid #444', ...canceledStyle }}>
                                                                    <td className="text-left" style={{ width: "16vw", ...baseFontStyle, ...canceledStyle }}>{bodyElement.CardName ?? ''}</td>
                                                                    <td className="text-center" style={{ ...baseFontStyle, ...canceledStyle }}>{bodyElement.OriginalNumAtCard ?? ''}</td>
                                                                    <td className="text-center" style={{ ...baseFontStyle, ...canceledStyle }}>{this.showNumAtCard(bodyElement)}</td>
                                                                    <td className="text-center" style={{ ...baseFontStyle, ...canceledStyle }}>{bodyElement?.DocNum ?? ''}</td>
                                                                    <td className="text-center" style={{ ...baseFontStyle, ...canceledStyle }}>{bodyElement.folio ?? ''}</td>
                                                                    <td className="text-center" style={{ ...baseFontStyle, ...canceledStyle }}>{`${bodyElement.docObjectType ?? ''}${bodyElement.referenceType ? `- ${bodyElement.referenceType}` : ''}`}</td>
                                                                    {/* <td className="text-center" style={{ ...baseFontStyle, ...canceledStyle }}>{this.getTipo(bodyElement)}</td> */}
                                                                    <td className="text-right mr-2" style={{ ...baseFontStyle, ...canceledStyle }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(bodyElement.Amount ?? 0.00)}</td>
                                                                </tr>
                                                                {detallesPago.length > 0 && (
                                                                    <>
                                                                        <tr style={{ borderTop: '1px solid #ccc', background: '#f5f5f5' }}>
                                                                            <th className="text-left" style={{ paddingTop: '8px', paddingBottom: '8px', ...baseFontStyle, color: '#555', fontWeight: '600' }}>N° Pago</th>
                                                                            <th className="text-left" style={{ paddingTop: '8px', paddingBottom: '8px', ...baseFontStyle, color: '#555', fontWeight: '600' }}>N° Documento</th>
                                                                            <th className="text-left" style={{ paddingTop: '8px', paddingBottom: '8px', ...baseFontStyle, color: '#555', fontWeight: '600' }}>No.Ref.de. Cliente</th>
                                                                            <th className="text-left" style={{ paddingTop: '8px', paddingBottom: '8px', ...baseFontStyle, color: '#555', fontWeight: '600' }}>Clase de Documento</th>
                                                                            <th className="text-left" style={{ paddingTop: '8px', paddingBottom: '8px', ...baseFontStyle, color: '#555', fontWeight: '600' }}>Fecha</th>
                                                                            <th className="text-right" style={{ paddingTop: '8px', paddingBottom: '8px', ...baseFontStyle, color: '#555', fontWeight: '600' }}>Total</th>
                                                                            <th className="text-right" style={{ paddingTop: '8px', paddingBottom: '8px', ...baseFontStyle, color: '#555', fontWeight: '600' }}>Pago Total</th>
                                                                            <th className="text-right" style={{ paddingTop: '8px', paddingBottom: '8px', ...baseFontStyle, color: '#555', fontWeight: '600' }}>Importe Percepción</th>
                                                                        </tr>
                                                                        {detallesPago.map((detail, idx) => (
                                                                            <tr key={idx} style={{ background: '#fafafa', borderBottom: '1px solid #e8e8e8' }}>
                                                                                <td className="text-left" style={{ paddingBottom: '8px', paddingTop: '6px', ...baseFontStyle }}>{detail.docNum ?? ''}</td>
                                                                                <td className="text-left" style={baseFontStyle}>{detail.DocNum ?? ''}</td>
                                                                                <td className="text-left" style={baseFontStyle}>{detail.NumAtCard ?? ''}</td>
                                                                                <td className="text-left" style={baseFontStyle}>{Number(detail.ObjType) === 13 ? 'Factura de cliente' : Number(detail.ObjType) === 30 ? 'Asiento de percepción' : detail.ObjType ?? ''}</td>
                                                                                <td className="text-left" style={baseFontStyle}>{detail.TaxDate ? moment(detail.TaxDate).format('YYYY-MM-DD') : ''}</td>
                                                                                <td className="text-right" style={baseFontStyle}>{`${CURRENCY} ${Number(detail.DocTotal ?? 0).toFixed(2)}`}</td>
                                                                                <td className="text-right" style={baseFontStyle}>{`${CURRENCY} ${Number(detail.totalPago ?? 0).toFixed(4)}`}</td>
                                                                                <td className="text-right" style={{ paddingBottom: '8px', ...baseFontStyle }}>{`${CURRENCY} ${Number(detail.U_PRC_IMP ?? 0).toFixed(2)}`}</td>
                                                                            </tr>
                                                                        ))}
                                                                        <tr>
                                                                            <td colSpan={8} style={{ borderBottom: '2px solid #bbb', padding: 0 }} />
                                                                        </tr>
                                                                    </>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='row mt-3'>
                                    <div className='col-5'></div>
                                    <div className='col-7'>
                                        <table>
                                            <tbody>
                                                {Number(element?.Total ?? 0) > 0 &&
                                                <tr>
                                                    <td className='text-right' style={{ background: "#ddd" }}><strong style={baseFontStyle}>{element.NamePayMethod ?? ''}: </strong></td>
                                                    <td className='text-right mr-2' style={{ background: "#ddd" }}><strong style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(element.Total ?? 0.00)}</strong></td>
                                                </tr>
                                                }
                                                {Number(element?.TotalCredito ?? 0) > 0 &&
                                                    <tr>
                                                        <td className='text-right' style={{ background: "#ddd" }}><strong style={{ color: 'blue', ...baseFontStyle }}>CRÉDITO: </strong></td>
                                                        <td className='text-right mr-2' style={{ background: "#ddd" }}><strong style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(element.TotalCredito ?? 0.00)}</strong></td>
                                                    </tr>
                                                }
                                                {Number(element?.TotalCanceled ?? 0) > 0 &&
                                                    <>
                                                        <tr>
                                                            <td className='text-right' style={{ background: "#ddd" }}><strong style={{ color: 'red', ...baseFontStyle }}>{`${element.NamePayMethod ?? ''} CANCELADO:`} </strong></td>
                                                            <td className='text-right mr-2' style={{ background: "#ddd" }}><strong style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(element.TotalCanceled ?? 0.00)}</strong></td>
                                                        </tr>
                                                    </>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        );
                    })
                }
                <div className='row mt-4'>
                    <div className='col-7'></div>
                    <div className='col-5'>
                        <table>
                            <tbody style={{ borderTop: "solid 1px" }}>
                                <tr>
                                    <td className='text-right p-2' style={{ background: "#ddd" }}><strong style={baseFontStyle}>GRAN TOTAL: </strong></td>
                                    <td className='text-right p-2 mr-2' style={{ background: "#ddd" }}><strong style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(Sales && Sales.BigTotal ? Sales.BigTotal : 0)}</strong></td>
                                </tr>
                                {Number(Sales?.BigTotalCredito ?? 0) > 0 &&
                                    <tr>
                                        <td className='text-right p-2' style={{ background: "#ddd" }}><strong style={{ color: 'blue', ...baseFontStyle }}>TOTAL CRÉDITO: </strong></td>
                                        <td className='text-right p-2 mr-2' style={{ background: "#ddd" }}><strong style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(Sales.BigTotalCredito)}</strong></td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2" style={baseFontStyle}>DEVOLUCIONES</th>
                            </tr>
                        </thead>

                    </table>

                    <table className='mt-2'>
                        <thead>

                            <tr>
                                <th className="text-left ml-5" style={baseFontStyle}>Folio</th>
                                <th className="text-left" style={baseFontStyle}>cliente</th>
                                <th className="text-left" style={baseFontStyle}>Nombre del cliente</th>
                                <th className="text-center" style={baseFontStyle}>Total</th>

                            </tr>
                        </thead>

                        <tbody>
                            {Returns && Returns.length > 0 &&
                                Returns.map((element, index) => {
                                    return (
                                        <tr key={'returnReport'+index}>
                                            <td className="text-left" style={baseFontStyle}>{element.folio ?? ''}</td>
                                            <td className="text-left" style={baseFontStyle}>{element.cardCode ?? ''}</td>
                                            <td className="text-left" style={baseFontStyle}>{element.CardName ?? ''}</td>
                                            <td className="text-right" style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(element.docTotal ?? 0)}</td>
                                        </tr>

                                    )
                                })


                            }

                        </tbody>
                    </table>

                </div>

                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2" style={baseFontStyle}>ENTRADAS Y SALIDAS</th>
                            </tr>
                        </thead>

                    </table>

                    <table className='mt-2'>
                        <thead>
                            <tr>
                                <th className="text-left ml-5" style={baseFontStyle}>Folio</th>
                                <th className="text-left" style={baseFontStyle}>Hora</th>
                                <th className="text-left" style={baseFontStyle}>Movimiento</th>
                                <th className="text-left" style={baseFontStyle}>Tipo</th>
                                <th className="text-right" style={baseFontStyle}>Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            {moneyMovements && moneyMovements.length > 0 &&
                                moneyMovements.map((element, index) => {
                                    return (
                                        <tr key={'returnReport'+index}>
                                            <td className="text-left" style={baseFontStyle}>{element.folio ?? ''}</td>
                                            <td className="text-left" style={baseFontStyle}>{moment(element.docTime ?? '').zone('-0200').format('HH:mm:ss') == 'Invalid date'? element.docTime : moment(element.docTime ?? '').zone('-0200').format('HH:mm:ss')}</td>
                                            <td className="text-left" style={baseFontStyle}>{element.docObjectType === -1 ? "Entrada" : 'Salida'}</td>
                                            <td className="text-left" style={baseFontStyle}>{element.pm_Name ?? ''}</td>
                                            <td className="text-right" style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(element.docTotal ?? 0)}</td>
                                        </tr>

                                    )
                                })
                            }
                        </tbody>
                    </table>

                </div>

                {/* GASTOS ADMINISTRATIVOS */}
                <div className='row mt-5 d-none' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="3" style={baseFontStyle}>GASTOS ADMINISTRATIVOS</th>
                            </tr>
                        </thead>
                    </table>
                    <table className='mt-2'>
                        <thead>
                            <tr>
                                <th className="text-left" style={baseFontStyle}>Factura Principal</th>
                                <th className="text-left" style={baseFontStyle}>Número de documento</th>
                                <th className="text-left" style={baseFontStyle}>No.Ref.de. cliente</th>
                                <th className="text-left" style={baseFontStyle}>Código de Cliente</th>
                                <th className="text-left" style={baseFontStyle}>Nombre de Cliente</th>
                                <th className="text-left" style={baseFontStyle}>Fecha</th>
                                <th className="text-left" style={baseFontStyle}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gastosAdministrativos?.length > 0 && gastosAdministrativos?.map((movement, index) => {
                                return (
                                    <tr key={'gaReport' + index}>
                                        <td className="text-left" style={baseFontStyle}>{movement.OriginalNumAtCard ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{movement.DocNum ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{movement.NumAtCard ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{movement.CardCode ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{movement.CardName ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{moment(movement.DocDate).format('YYYY-MM-DD') ?? ''}</td>
                                        <td className="text-right" style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(movement.DocTotal ?? 0)}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>

                {/* CESION EN USO */}
                <div className='row mt-5 d-none' style={{ paddingRight: "15px" }}>
                    <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                            <tr>
                                <th className="text-center" colSpan="2" style={baseFontStyle}>CESIÓN EN USO</th>
                            </tr>
                        </thead>
                    </table>

                    <table className='mt-2'>
                        <thead>
                            <tr>
                                <th className="text-left" style={baseFontStyle}>Factura Principal</th>
                                <th className="text-left" style={baseFontStyle}>Tipo</th>
                                <th className="text-left" style={baseFontStyle}>Número de documento</th>
                                <th className="text-left" style={baseFontStyle}>No.Ref.de. cliente</th>
                                <th className="text-left" style={baseFontStyle}>Código de Cliente</th>
                                <th className="text-left" style={baseFontStyle}>Nombre de Cliente</th>
                                <th className="text-left" style={baseFontStyle}>Fecha</th>
                                <th className="text-left" style={baseFontStyle}>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cesionEnUso?.length > 0 && cesionEnUso?.map((movement, index) => {
                                return (
                                    <tr key={'cuReport' + index}>
                                        <td className="text-left" style={baseFontStyle}>{movement.OriginalNumAtCard ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{movement.ObjType ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{this.mDocCum(movement)}</td>
                                        <td className="text-left" style={baseFontStyle}>{this.mNumAtCard(movement)}</td>
                                        <td className="text-left" style={baseFontStyle}>{movement.CardCode ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{movement.CardName ?? ''}</td>
                                        <td className="text-left" style={baseFontStyle}>{moment(movement.DocDate).format('YYYY-MM-DD') ?? ''}</td>
                                        <td className="text-right" style={baseFontStyle}>{CURRENCY + ' ' + FORMAT_NUMBER.new(movement.DocTotal ?? 0)}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>

                <br />
                <br />
                <br />
            </div >
        )
        
    }
}

export default DetailPayments